import React from 'react';
import PropTypes from 'prop-types';
import FilterCustom from 'components/common/FilterCustom';
import CompanyFilterForm from './CompanyFilterForm';

const CompanyFilter = ({ retrieveList, greyInput = true }) => {
  const onSubmitFilter = (values) => {
    retrieveList({
      filter: {
        outsideFilter: values,
        offset: 0,
      },
      isRefresh: true,
      keepFilter: false,
    });
  };

  const onClearFilter = () => {
    retrieveList({
      filter: {
        offset: 0,
      },
      isRefresh: true,
      keepFilter: false,
    });
  };

  return (
    <FilterCustom
      greyInput={greyInput}
      onSubmitFilter={onSubmitFilter}
      onClearFilter={onClearFilter}
    >
      <CompanyFilterForm />
    </FilterCustom>
  );
};

CompanyFilter.propTypes = {
  retrieveList: PropTypes.func,
  greyInput: PropTypes.bool,
};

export default CompanyFilter;
